module.exports = __webpack_public_path__ + "static/media/Transcriptions_README_modifiedForApp.94bf323c.md";